var map = {
	"./asset_ui/src/blocks/context.js": 97885,
	"./communication_ui/src/blocks/context.js": 53669,
	"./file_ui/src/blocks/context.js": 98565,
	"./invoice_ui/src/blocks/context.js": 15318,
	"./ks_app/src/blocks/context.js": 31562,
	"./lms_ui/src/blocks/context.js": 24469,
	"./market_ui/src/blocks/context.js": 93427,
	"./marketing_ui/src/blocks/context.js": 10817,
	"./payment_ui/src/blocks/context.js": 34035,
	"./rms_ui/src/blocks/context.js": 2491,
	"./task_ui/src/blocks/context.js": 12346
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31567;